var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{attrs:{"color":_vm.bloqueado === _vm.valor ? 'red' : 'green',"dark":"","x-small":""}},[_vm._v(" "+_vm._s(_vm.bloqueado === _vm.valor ? 'NÂO' : 'SIM')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }